import apiClient from '@/api/apiClient.js';
import { getPatPatientsId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    catDepartments: [],
    modelForm: {},
    data: {},
    status: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    catDepartments(state) {
      return state.catDepartments;
    },
    modelForm(state) {
      return state.modelForm;
    },
    data(state) {
      return state.data;
    },
    status(state) {
      return state.status;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertCatDepartments(state, catDepartments) {
      state.catDepartments = catDepartments;
    },
    insertModelForm(state, modelForm) {
      state.modelForm = modelForm;
    },
    saveData(state, data) {
      state.status = 'success';
      state.data = data;
    },
    saveError(state) {
      state.status = 'error';
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        var res = await apiClient.patProfileASchema();
        const schema = res.data;

        const resCat3 = await apiClient.catBirthSexes();
        const catBirthSexes = resCat3.data.data;

        const resCat4 = await apiClient.catISO3366_1();
        const catISO3366_1 = resCat4.data.data;

        const resCat5 = await apiClient.catDepartments();
        var catDepartments = resCat5.data.data;

        const resCat8 = await apiClient.catYear();
        const catYear = resCat8.data.data;

        schema.schemaForm.group2.schema.birth_sexes_birth_sexes_id.items = catBirthSexes;
        schema.schemaForm.group2.schema.users_birth_iso3366.items = catISO3366_1;
        schema.schemaForm.group2.schema.users_birth_department.items = catDepartments;
        schema.schemaForm.group2.schema.users_birth_date_year.items = catYear;
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadCatDepartments({ commit }) {
      try {
        const res = await apiClient.catDepartments();
        const catDepartments = res.data.data;
        commit('insertCatDepartments', catDepartments);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadModelForm({ commit }, payload) {
      try {
        const id = getPatPatientsId();

        let model = {};
        if (payload === undefined) {
          model.usersPin = false;
        } else {
          const usersPin = payload.usersPin;
          model.usersPin = usersPin;
        }

        const res = await apiClient.modelPatProfileA(id, model);
        let modelForm = res.data.data;
        const patients_npat = modelForm.patients_npat;

        let group1 = {};

        const filteredKeys2 = [
          'birth_sexes_birth_sexes_id',
          'users_birth_date_year',
          'users_birth_date_month',
          'users_birth_iso3366',
          'users_birth_department',
        ];
        const group2 = filteredKeys2.reduce((obj, key) => ({ ...obj, [key]: modelForm[key] }), {});
        modelForm = { group1, group2 };
        modelForm.group2.patProfileData = true;
        modelForm.group1.patient_internal_code = patients_npat;
        modelForm.group2.users_birth_iso3366 = 'PE';
        commit('insertModelForm', modelForm);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async save({ commit }, model) {
      try {
        const id = getPatPatientsId();
        const res = await apiClient.updatePatProfileA(id, model);
        let data = {};
        data.statusText = res.statusText;
        commit('saveData', data);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error guardando');
        commit('saveError');
        throw error;
      }
    },
  },
};
